export const REACT_APP_SUPABASE_URL: string =
  process.env.REACT_APP_SUPABASE_URL!;
export const REACT_APP_SUPABASE_KEY: string =
  process.env.REACT_APP_SUPABASE_KEY!;
